import ToastHighLighter from '@/lib/ToastHighLighter';

export const FormSelectCode = () => {
  const language = 'html';
  const codeString = `
  // Select2 - example
  <label htmlFor="single-select-field">Select single - Standard</label>
  <select className="sel2 col-12" id="single-select-field">
    <option value="FHNW">Hochschulen der FHNW</option>
    <option value="APS">Hochschule für Angewandte Psychologie</option>
    <option value="APS">
      Hochschule für Architektur, Bau und Geomatik
    </option>
    <option value="HGK">Hochschule für Gestaltung und Kunst</option>
    <option value="HLS">Hochschule für Life Science</option>
    <option value="APS">Hochschule für Musik</option>
    <option value="PH">Pädagogische Hochschule</option>
    <option value="HSA">Hochschule für Soziale Arbeit</option>
    <option value="HT">Hochschule für Technik</option>
    <option value="HSW">Hochschule für Wirtschaft</option>
  </select>
`;

  return (
    <>
      <ToastHighLighter
        name={'formselect'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const FormSelectJSCode = () => {
  const language = 'javascript';
  const codeString = `
  // Select2 - jQuery
  // See script in default.js
  
  $('#single-select-field').select2({
    theme: 'bootstrap-5',
    closeOnSelect: true,
    placeholder: 'Lorem ipsum',
    selectionCssClass: 'select2--small',
    dropdownCssClass: 'select2--small',
  });
`;

  return (
    <>
      <ToastHighLighter
        name={'formselectjs'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
